import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";

import App from './App';
import { getConfig } from "./config";
import { getLocal, setLocal } from './utils/api';
import history from "./utils/history";
import reportWebVitals from './reportWebVitals';

import './index.css';

const locationParts = window.location.pathname.split('/');

if (locationParts.length === 3 && locationParts[1] === 'referral' && locationParts[2]) {
  setLocal('referralCode', locationParts[2]);
}

const onRedirectCallback = (appState) => {
  setLocal('login', true);
  
  history.push(
    appState && appState.returnTo ? appState.returnTo : window.location.pathname
  );
};

// Please see https://auth0.github.io/auth0-react/interfaces/Auth0ProviderOptions.html
// for a full list of the available properties on the provider
const config = getConfig();

const providerConfig = {
  domain: config.domain,
  clientId: config.clientId,
  onRedirectCallback,
  authorizationParams: {
    redirect_uri: window.location.origin,
    screen_hint: (getLocal('referralCode') ? 'signup' : 'login'),
    ...(config.audience ? { audience: config.audience } : null),
  },
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Auth0Provider {...providerConfig}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Auth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
